module.exports = __webpack_public_path__ + "img/screen_12.7d1910ab.svg";